import { useState, useEffect } from "react";
import { motion } from "framer-motion";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = ["Hiatus Watch", "The Story", "Testimonies", "Trending"];
  const ids = ["hero", "article", "quotes", "trending"];

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.25, 1, 0.5, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 border-b transition-colors duration-500 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-white/10" : "bg-transparent border-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-6 sm:px-10 h-16">
        <a href="#hero" data-testid="header-logo" className="flex items-center gap-3">
          <div className="w-7 h-7 bg-[#4ADE80] flex items-center justify-center">
            <span className="font-display text-black text-lg leading-none mt-0.5">24</span>
          </div>
          <span className="font-display text-2xl tracking-wide text-white">
            MCNEWS<span className="text-[#4ADE80]">24</span>
          </span>
          <span className="hidden sm:block font-mono-news text-[10px] text-zinc-500 uppercase tracking-widest border border-white/10 px-2 py-0.5">
            Minecraft Creator News
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link, i) => (
            <a
              key={link}
              href={`#${ids[i]}`}
              data-testid={`nav-link-${ids[i]}`}
              className="link-underline font-mono-news text-xs uppercase tracking-widest text-zinc-400 hover:text-white transition-colors duration-300"
            >
              {link}
            </a>
          ))}
        </nav>
        <div data-testid="header-live-badge" className="flex items-center gap-2 font-mono-news text-xs uppercase tracking-widest text-red-400">
          <span className="live-dot" />
          <span className="hidden sm:inline">Day 127 Offline</span>
          <span className="sm:hidden">D127</span>
        </div>
      </div>
    </motion.header>
  );
};
